import {Component} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Employee, EmployeesV1Service, Department} from "../../../apis/backend";
import {BehaviorSubject, firstValueFrom} from "rxjs";

@Component({
    selector: 'employee-dialog',
    templateUrl: './employee-dialog.component.html',
})
export class EmployeeDialogComponent {

    public Employee: Employee = <Employee>{
        Departments: [],
    };

    public DepartmentValues: Department[];
    public DepartmentsLoaded = new BehaviorSubject<boolean>(false);
    public NewDepartment: Department;
    
    constructor(
        public ActiveModal: NgbActiveModal,
        public EmployeeApiService: EmployeesV1Service) {
        firstValueFrom(this.EmployeeApiService.getDepartments())
            .then(departments => {
                this.DepartmentValues = departments;
                this.DepartmentsLoaded.next(true);
            });
    }

    public ParseDate(dateStr: string) {
        return new Date(dateStr);
    }
    
    public get AvailableDepartments() {
        return this.DepartmentValues
            .filter(d1 => !this.Employee.Departments
                .some(d2 => d2.DepartmentID == d1.DepartmentID));
    }

    public CompareDepartments(department1: Department, department2: Department) {
        return department1?.DepartmentID == department2?.DepartmentID;
    }
    
    public AddDepartment() {
        if (!this.NewDepartment) {
            return;
        }
        this.Employee.Departments.push(this.NewDepartment);
        this.NewDepartment = null;
    }
    
    public DeleteDepartment(index: number) {
        this.Employee.Departments.splice(index, 1);
    }
    
    public Save() {
        this.ActiveModal.close(this.Employee);
    }
    
    public Cancel() {
        this.ActiveModal.dismiss();
    }
}